import HomeIcon from "./icons/logo.svg?react";

import { faList, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

import { NavAsideInfo } from "./components/NavAside";
import { fa } from "./report/sections/util";
export const menuInfo: NavAsideInfo[] = [
  ["", "Kaart", "Kaart", HomeIcon],
  ["search", "Zoek", "Zoek", fa(faMagnifyingGlass)],
  ["workspaces", "Werkruimtes", "Werkruimtes", fa(faList)],
];
